import { IconButton } from '@mui/material';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { useNavigate } from 'react-router';
import { useAppSelector } from '@reduxStore';
import { selectAppFeatures } from '@/Infrastructure/Utilities/appSelectors';

import styles from '../DataGrid.Dispatch.module.css';

/**
 * Opens the Edit Board Queries page, carrying the currently selected query along so the editor can open it.
 */
export default function EditBoardQueriesButton(props: { terminalNumber: string; queryName: string }) {
	const featureFlags = useAppSelector((state) => selectAppFeatures(state));
	const navigate = useNavigate();

	if (!featureFlags?.editBoardQueries) return <></>;

	const handleClick = () => {
		void navigate(`/${props.terminalNumber}/queries?query=${encodeURIComponent(props.queryName)}`);
	};

	return (
		<IconButton
			title='Edit Board Queries'
			onClick={handleClick}
			className={`${styles['icon-btn']} ${styles['edit-queries-btn']}`}
		>
			<EditTwoToneIcon />
		</IconButton>
	);
}
